<template>
    <div id='login' style='height: 20vh;'>
        <form-pl :id="'login'"  ref="loginform"/>
    </div>    
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import FormPL from '@/components/FormPL';

    export default {
        name:"Login",
        components: {
            'form-pl' : FormPL,
        },
        mixins: [FctUtils],
        mounted() {
            console.log((this.$store.state.currentTokenInfo));
            var isConnected = FctUtils.methods.noEmpty(this.$store.state.currentTokenInfo) && FctUtils.methods.noEmpty(this.$store.state.currentUser);

            if (!isConnected) {
                //this.$root.$emit('showPLForm', {mode: 'login', data:{}});
                //this.bus.$emit('showPLForm', {mode: 'login', data:{}});
                this.$refs.loginform.showForm({mode: 'login', data:{}});
            }
            else {
                this.$router.push("/accueil")
            }
        },
        methods : {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1 {
    line-height: 38px;
    text-align: left;
    font-weight: 400;
    font-size: 2.5em;
    margin-top: 0;
    margin-bottom: 20px;
}

</style>
